<app-button-close-dialog></app-button-close-dialog>
<h2 mat-dialog-title>Acción realizada :: <strong>{{ data.accion == accionesDialog.Agregar ? 'Crear' : data.accion ==
    accionesDialog.Eliminar ? 'Eliminar': data.accion == accionesDialog.Ver
    ? 'Ver' : 'Modificar' }} </strong></h2>

<ngx-spinner [zIndex]="100" name="spMovimientoExpediente" bdColor="rgba(255,255,255,0.8)" size="default"
  color=" var(--primary-color)" type="ball-atom" [fullScreen]="false">
</ngx-spinner>

<mat-dialog-content cdkTrapFocus [cdkTrapFocusAutoCapture]="true" *ngIf="data.accion != accionesDialog.Ver">
  <form [formGroup]="form">
    <ng-container *ngIf="data.accion == accionesDialog.Eliminar; else formTemplate">
      ¿Esta seguro que desea eliminar el registro <b>{{data.descripcion}}</b>?
    </ng-container>

    <ng-template #formTemplate>
      <div class="row" *ngIf="this.data?.idExpediente == undefined &&  data.accion == accionesDialog.Agregar">
        <div class="col">
          <app-buscar-expediente formControlName="IdExpediente"
            (eventEntity)="selectExpediente($event)"></app-buscar-expediente>
        </div>
      </div>

      <div class="row">
        <div class="col">

          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Fecha</mat-label>
            <input matInput [matDatepicker]="picker" formControlName="Fecha">
            <mat-hint>MM/DD/YYYY</mat-hint>
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
            <mat-error *ngIf="f.Fecha.errors?.required">Este campo es <strong>requerido</strong>.</mat-error>
          </mat-form-field>
        </div>
        <div class="col">

          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Descripción</mat-label>
            <input cdkFocusInitial matInput type="text" maxlength="100" style="text-transform: uppercase"
              formControlName="Descripcion" />
            <mat-error *ngIf="f.Descripcion.errors?.required">Este campo es <strong>requerido</strong>.</mat-error>

            <mat-error *ngIf="f.Descripcion.errors?.maxlength">Superó el largo máximo.</mat-error>

          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <mat-form-field appearance="outline" class="w-100">
            <ngx-spinner [zIndex]="-1" name="spTiposmovimientoExpediente" bdColor="rgba(255,255,255,0.8)" size="small"
              color=" var(--primary-color)" type="line-scale" [fullScreen]="false"></ngx-spinner>
            <mat-label>Estado</mat-label>
            <mat-select placeholder="Seleccione opcion" formControlName="IdEstadoMovimientoExpediente">
              <mat-option [value]="estadoMovimientoExpediente.id" *ngFor="
                  let estadoMovimientoExpediente of estadosMovimientoExpediente;
                  let i = index;
                  trackBy: trackByItems
                ">
                {{ estadoMovimientoExpediente.descripcion }}</mat-option>
            </mat-select>
            <mat-error *ngIf="f.IdEstadoMovimientoExpediente.errors?.required">Este campo es
              <strong>requerido</strong>.</mat-error>

          </mat-form-field>
        </div>
      </div>

      <div class="row">
        <mat-form-field appearance="outline" class="w-100" *ngIf="!data.esEliminar; else elseTemplate">
          <mat-label>Observaciones</mat-label>
          <textarea matInput #message name="Observaciones" formControlName="Observaciones"></textarea>
          <mat-hint align="start">Amplie información</mat-hint>
          <mat-hint align="end">{{ message.value.length }} / 200</mat-hint>


          <mat-error *ngIf="f.Observaciones.errors?.maxlength">Supero el largo
            maximo.</mat-error>
        </mat-form-field>
      </div>


    </ng-template>
  </form>

</mat-dialog-content>

<mat-dialog-content cdkTrapFocus [cdkTrapFocusAutoCapture]="true" *ngIf="data.accion == accionesDialog.Ver">

  <div *ngIf="data">
    <div>
      <div class="property-row">
        <span class="property-name">Fecha:</span>
        <span class="property-value">{{ data.item?.fecha | date:'short' }}</span>
      </div>
      <div class="property-row">
        <span class="property-name">Estado:</span>
        <span class="property-value">{{ data.item?.estadoMovimientoExpediente?.descripcion }}</span>
      </div>
      <div class="property-row">
        <span class="property-name">Descripción:</span>
        <span class="property-value">{{ data.item?.descripcion }}</span>
      </div>
      <div class="property-row">
        <span class="property-name">Observaciones:</span>
        <span class="property-value">{{ data.audiencia?.observaciones }}</span>
      </div>
    </div>

  </div>


</mat-dialog-content>


<mat-dialog-actions align="end">
  <app-button-cancel-dialog></app-button-cancel-dialog>
  <app-button-add *ngIf="data.accion == accionesDialog.Agregar" [disabled]="!form.valid"
    (click)="agregar()"></app-button-add>

  <app-button-save [disabled]="!form.valid" [isDialogClose]="true" (saveClicked)="modificar()"
    (cancelClicked)="cancelar()" *ngIf="data.accion == accionesDialog.Modificar"></app-button-save>

  <app-button-delete (click)="eliminar()" (cancelClicked)="cancelar()" *ngIf="data.accion == accionesDialog.Eliminar"
    [isDialogClose]="true"></app-button-delete>
</mat-dialog-actions>
